import { render, staticRenderFns } from "./BmvToastContainer.vue?vue&type=template&id=5021e710&scoped=true"
import script from "./BmvToastContainer.vue?vue&type=script&lang=js"
export * from "./BmvToastContainer.vue?vue&type=script&lang=js"
import style0 from "./BmvToastContainer.vue?vue&type=style&index=0&id=5021e710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5021e710",
  null
  
)

export default component.exports